import { render, staticRenderFns } from "./SubItem.vue?vue&type=template&id=238c9340"
import script from "./SubItem.vue?vue&type=script&lang=js"
export * from "./SubItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports